import React from 'react';
import styled from 'styled-components';
import { FaBars, FaUser } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

interface MobileHeaderProps {
  onMenuToggle: () => void;
}

const HeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const Logo = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: white;
  
  .vr {
    color: ${(props) => props.theme?.colors?.secondary?.main || '#e4312e'};
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

const UserAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${(props) => props.theme?.colors?.secondary?.main || '#e4312e'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuToggle }) => {
  const { currentUser } = useAuth();

  console.log('MobileHeader rendered');

  const getUserInitials = (name: string | null) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  const handleMenuClick = () => {
  console.log('[MobileHeader] handleMenuClick. Menu button clicked');

    console.log('Menu button clicked in MobileHeader');
    onMenuToggle();
  };

  return (
    <HeaderContainer>
      <MenuButton onClick={handleMenuClick}>
        <FaBars />
      </MenuButton>
      
      <Logo>
        <span className="vr">VR</span>
        <span className="simracers">Simracers</span>
      </Logo>
      
      <UserInfo>
        <UserAvatar>
          {currentUser?.photoURL ? (
            <img src={currentUser.photoURL} alt={currentUser.displayName || 'Usuario'} />
          ) : currentUser?.displayName ? (
            getUserInitials(currentUser.displayName)
          ) : (
            <FaUser />
          )}
        </UserAvatar>
      </UserInfo>
    </HeaderContainer>
  );
};

export default MobileHeader;
